export const SUBTASK_STATUSES = {
  ANALYZED: "analyzed_sub_task_status",
  RESOLVED: "resolved_sub_task_status",
  FINISHED: "finished_sub_task_status",
  NEW: "new_sub_task_status",
  WORNG: "worng_sub_task_status",
  READY_FOR_REVIEW: "ready_for_review_sub_task_status",

  SAMPLING: "sampling_iw_sub_task_status",
  EXCEL_TO_LAB: "excel_to_lab_iw_sub_task_status",
  EXCEL_TO_LAB_MIBI: "excel_to_lab_mibi_iw_sub_task_status",
  RESULT_CHECK: "result_check_iw_sub_task_status",
  REPORT_CREATION: "report_creation_iw_sub_task_status",
  PLANT_TURN_ON: "plant_turn_on_sub_task_status",
  SIGN_REPORT: "sign_report_sub_task_status",

  RISK_ASSESSMENT_TRANSFER: "risk_assessment_transfer_sub_task_status",
  ACTION_EVALUATION: "action_evaluation_sub_task_status",
  CUSTOMER_ACTION_SELECTION: "customer_action_selection_sub_task_status",
  ACTION_EXECUTION: "action_execution_sub_task_status",

  LEGIONELLA_REPORT_1: "legionella_report_1_sub_task_status",
  LEGIONELLA_MEASURES: "legionella_measures_sub_task_status",
  LEGIONELLA_AWAIT_RESAMPLE: "legionella_await_resample_sub_task_status",
  LEGIONELLA_REPORT_2: "legionella_report_2_sub_task_status",
} as const;

export type SubTaskStatus =
  (typeof SUBTASK_STATUSES)[keyof typeof SUBTASK_STATUSES];

/**
 * Phases of the "Über 10000 KBE/100ml Legionellen im System" task. Tasks created
 * before that workflow existed sit on NEW and only show the instructions text, so
 * the phase UI keys off this list.
 */
export const HIGH_LEGIONELLA_PHASE_STATUSES = [
  SUBTASK_STATUSES.LEGIONELLA_REPORT_1,
  SUBTASK_STATUSES.LEGIONELLA_MEASURES,
  SUBTASK_STATUSES.LEGIONELLA_AWAIT_RESAMPLE,
  SUBTASK_STATUSES.LEGIONELLA_REPORT_2,
] as const;

export type HighLegionellaPhaseStatus =
  (typeof HIGH_LEGIONELLA_PHASE_STATUSES)[number];

export const isHighLegionellaPhaseStatus = (
  statusKey?: string | null
): statusKey is HighLegionellaPhaseStatus =>
  HIGH_LEGIONELLA_PHASE_STATUSES.includes(statusKey as HighLegionellaPhaseStatus);
